@if (available()) {
  <div>
    <service-tile-available
      [serviceUrl]="serviceUrl()"
      [serviceTitle]="serviceTitleKey() | translate"
      [serviceBody]="'Subscription.' + key().toString() + '.Description' | translate"
      [serviceIcon]="key() | lowercase"
      [forceColor]="forceColor()"
      [actionButtonText]="actionButtonText()"
    >
    </service-tile-available>
  </div>
} @else {
  <service-tile
    [serviceUrl]="key()"
    [serviceTitle]="serviceTitleKey() | translate"
    [serviceIcon]="key() | lowercase"
    [serviceMessage]="serviceMessage()"
    [healthIndicators]="subscription().value.counts"
    [isLoading]="isLoading()"
    [firewallCount]="firewallCount()"
    [subscriptionCount]="subscriptionCount()"
    [serviceMessages]="serviceMessages()"
    [serviceMessageAmount]="customerActivities().length"
    [wirelessEnabled]="wirelessEnabled()"
    [vulnerabilitiesDetectedCount]="vulnerabilitiesDetectedCount()"
    [actionButtonText]="actionButtonText()"
  >
  </service-tile>
}
